import React from 'react';
import PropTypes from 'prop-types';

import { ASmartField } from '../../atoms';

export default class OSmartInputSection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const optioneel = this.props.optional ? <p>(optioneel)</p> : undefined;
		let filteredItems;
		if (this.props.items && this.props.value) {
			filteredItems = this.props.items.filter(item => !this.props.value.find(valueItem => item.uuid === valueItem.uuid));
		}

		return (
			<section className={`o-section-smart-input ${this.props.className}`}>
				<div className="o-section-title">
					<h3>{this.props.title}</h3>
					{optioneel}
				</div>
				{
					this.props.value.map(item => (
						<ASmartField
							id={item.uuid}
							key={item.uuid}
							value={item}
							className="o-set-sections"
							onDelete={() => { this.props.onDelete(item.uuid); }}
						/>
					))
				}
				<ASmartField
					id={`smAdd${this.props.title}`}
					items={filteredItems || this.props.items}
					value={{ name: '' }}
					onSelect={(option) => { if (option) { this.props.onSelect(option); } }}
				/>
			</section>
		);
	}
}

OSmartInputSection.propTypes = {
	title: PropTypes.string,
	value: PropTypes.array,
	items: PropTypes.array,
	className: PropTypes.string,
	optional: PropTypes.bool,
	onDelete: PropTypes.func,
	onSelect: PropTypes.func,
};

OSmartInputSection.defaultProps = {
	title: '',
	value: [],
	items: undefined,
	className: '',
	onDelete: undefined,
	onSelect: undefined,
	optional: false,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.smart-input-section.js